import React from 'react';
import { ManualInvoiceAdjustmentPanel } from '../components/ManualInvoiceAdjustmentPanel';

export const AjustarFacturasPage: React.FC = () => {
  return <ManualInvoiceAdjustmentPanel />;
};
